import React, { useEffect, useRef, useState } from "react";
import DOMPurify from 'dompurify';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import apiClient from '../../../../services/apiClient';
import "./custom.css";
import UnitOption from "./UnitOption";
import CommonDropdownMenuThree from "../../../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../../../Shared/CommonDropdownMenufour";
import Swal from "sweetalert2";


function ViewContractInfoModal({user,type,id,code,data}) {

  const [pagescontent, setPagescontent] = useState([]);
    const [showsign, setshowsign] = useState(true);

    const [usersignature, setUsersignature] = useState('');

     const [username, setusername] = useState('');
      const [useremail, setuseremail] = useState('');
      const [customername, setcustomername] = useState('');
      const [customeremail, setcustomeremail] = useState('');

      const [customersignature, setcustomersignature] = useState('');
      const [signaturebox, setsignaturebox] = useState("");
      const [isChecked, setIsChecked] = useState(false);

      const [companylogo, setCompanylogo] = useState();
    
      const [phone, setPhone] = useState();
      const [companyemail, setCompanyemail] = useState();
        const [fname, setFname] = useState();
        const [lname, setLname] = useState();
         const [companyname, setcompanyname] = useState();
        
      const [invoicecode, setinvoicecode] = useState(0); 
      const [purchageorder, setpurchageorder] = useState('');

       const [smartdate, setsmartdate] = useState(false);
        const [smartday, setsmartday] = useState("");
        const [smartmonth, setsmartmonth] = useState(false);
        const [smartyear, setsmartyear] = useState(false);
          const [proposalstabs, setProposalstabs] = useState([]);

        const options = ["Custom Date", 'Smart date'];
  const options_sub = ["Payment is due on a fixed calendar date", 'Payment due date is based on event or invoice date'];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

       const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

      const formattedDate = `${months[currentDate.getMonth()]
    } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

    const [subtotalprice, setsubtotalprice] = useState(0);
    const [showTaxBox, setShowTaxBox] = useState(false);
    const [taxval, settaxval] = useState(0);
    const [discountval, setdiscountval] = useState(0);
     const [showDiscountBox, setShowDiscountBox] = useState(false);
      const [totalprice, settotalprice] = useState(0);

      const [showDueDateBox, setShowDueDateBox] = useState(null);


     const [popup, setpopup] = useState(false);
      const [placeholder2,setplaceholder2] = useState('Type Placeholder here');
      const [addedoptions,setaddedoptions] = useState([{listpotion:'option'},{listpotion:'option'}]);
      const [question, setQuestion] = useState([]);
      const [title2,settitle2] = useState('Type your question here');


        const handleChange = (event) => {
    setsignaturebox(event.target.value);
  };
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  const addsignature = async () => {

  const formData = new FormData();
  formData.append('sharedid', id);
  formData.append('signature', signaturebox);
  

try {
      /* const response = await apiClient.post(`/setcustomersign', 
                     {sharedid: contractid,
                     });  */

      const response = await apiClient.post(`/setusersign`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        // alert('Email send Sucessfully');
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Action complete Sucessfully!",
        });
        // navigate("/events");
      }

      setUsersignature(signaturebox);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    }



  }
        

     
       
        
  
   useEffect(() => {
    
      //  dispatch(setTitle(data.sharedQuestionnaires.title));



      //  setshareduserdetail(data.user);

     settitle2(data.question1);
     setplaceholder2(data.placeholder1);

  const pages=JSON.parse(data.pages);

 
  setPagescontent(pages);

   setCompanylogo(user.Main_Logo ? process.env.REACT_APP_BACKEND_URL + user.Main_Logo : null);

          setPhone(user.Phone_Number);
          setCompanyemail(user.Company_Email);
          setFname(user.first_name);
          setLname(user.last_name);

          setusername(data.username);
          setcustomername(data.customer_name);
          if(data.signed!=null){
          setcustomersignature(data.signed);
          }
          if(data.usersignature!=null){
          setUsersignature(data.usersignature);
          }

          
  
     
   
  }, []);

   

  return (
    <div
      className='modal fade'
      id={`exampleModalc${id}${code}`}
      tabIndex='-1'
      aria-labelledby='exampleModalLabel'
      aria-hidden='true'
       style={{ background:'#fffff'}}
    >
      <div
        className='modal-dialog modal-lg modal-dialog-centered'
        role='document'
        style={{ minHeight: "700px" }}
      >
        <div className='modal-content'>
          {/* Modal header */}
          <div className='modal-header bg-primary'>
            <h5 className='modal-title text-white w-100 text-center' style={{ textTransform:'uppercase'}}>
              {type} 
            </h5>
            <button type='button' className='close' data-bs-dismiss='modal'>
              <span aria-hidden='true' className='modal_button'>
                <i className='fas fa-close'></i>
              </span>
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='modal-body py-5 px-4' style={{ background: "#ffffff" }} >
            <div className='row'>


               <div className='customer_details' style={{ textAlign: "left" }}>
                        {/* Customer info */}
                        {companylogo ? (
                          <>
                           {/*  <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div> */}
                          </>
                        ) : (<>

                        </>)}
                        {/* <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div> */}
                      </div>



                      {pagescontent.map((item, index) => ( <>
                
                                  <div className="row left">
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }} />
                                  </div>
                            </>
                      ))}


            {/* signature part start   */}

          {showsign && (<>

                <div className={"tab-pane"} id='sign' role="tabpanel" aria-labelledby={`sign-tab`} style={{ background: 'white', height: '100%' }} >

                  <div className="position-relative overflow-hidden">

                    <div className="signat">

                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>




                      {usersignature && usersignature !== "NULL" && (<>
                        <div className="signaturemain left w-100">
                          {usersignature}
                        </div>
                      </>)}

                       {usersignature == "" && (<>
                        <div className="addbutton">
                          <button
                            className={`nav-link add_Signature`}
                            type='button'
                            data-bs-toggle='offcanvas'
                            data-bs-target='#signpopupcontact'
                            aria-controls='offcanvasRight'
                          >Add Signature </button>

                        </div>
                      </>)}



                      <div className="sign_text">{username}  </div>
                      <div className="sign_text">{useremail}</div>

                      <div className="gap"> <hr /> </div>

                     

                      {customersignature != "" && (<>
                        <div className="signaturemain left w-100">
                          {customersignature}
                        </div>
                      </>)}

                      <div className="sign_text">{customername} </div>
                      <div className="sign_text">{customeremail}</div>


                    </div>

                  </div>

                </div>
              </>)}


              {/* signature part end  */}

            </div>
           
           
           
          </div>
        </div>
      </div>



 {/* start of the sign popup */}
      <div
        className='offcanvas offcanvas-end'
        tabIndex='-1'
        id='signpopupcontact'
        aria-labelledby='offcanvasRightLabel'
        data-bs-backdrop='false'>
        <div class='w-100 text-start header'>
          <button
            type='button'
            class='btn-close mt-3 ms-4 text-black'
            data-bs-dismiss='offcanvas'
            aria-label='Close'></button>


          <div className='text-center py-3'>
            <h5>Signature</h5>
            <span style={{ color: "#727272" }}>
              Add Your Signature
            </span>
          </div>
        </div>


        <div class='offcanvas-body p-0'>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="text" className="signbox" onChange={handleChange} value={signaturebox} />
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="checkbox" onChange={handleCheckboxChange} />By Clicking, I, <b> {username}  </b> hereby consent to the use of my electronic signature for the execution of this document. I acknowledge and agree that my electronic signature shall have the same validity, enforceability, and legal effect as my handwritten signature.
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <button
                  type='button'
                  class='mt-3 ms-4 text-black backbackground add_Signature'
                  data-bs-dismiss='offcanvas'
                  disabled={!isChecked}
                  onClick={addsignature}
                  aria-label='Close'>SIGN</button>
              </div>
            </div>
          </div>

        </div>







      </div>



      {/* end of the sign popup */}






    </div>







  );
}

export default ViewContractInfoModal;
